import React from "react";
import "./CmProfilePage.Styles.css";
import EditProfile from "../../Component/ExpertEditProfile/ExpertEditProfile";
import Layout from '../../NewComponent/LayoutAdmin/Layout';

export default function CmProfilePage2() {
    return (
        <>
            <div style={{ marginBottom: "7%" }}>
                <Layout>
                    <div className="container">
                        <div className="midContainerOpen">
                            <div className="headingTop">
                                <h3>Edit Profile</h3>
                            </div>
                            <EditProfile />
                        </div>
                    </div>
                </Layout>
            </div>
        </>
    )
}